import styled from "@emotion/styled";

import { fontRoboto, fontRobotoCondensed } from "shared/lib/styles";

import { Figure } from "scmp-app/components/content/content-cover-image/styles";
import { EntityLink } from "scmp-app/components/entity-link";

export const Container = styled.div`
  display: flex;
  flex-direction: column;

  block-size: 100%;
`;

export const StyledEntityLink = styled(EntityLink)`
  display: flex;
  flex: 1;
  flex-direction: column;

  color: #000000;

  &:hover {
    color: #2c4692;
  }
`;

export const CoverImage = styled.div`
  position: relative;
  ${Figure} {
    aspect-ratio: 3/2;
  }
`;

export const Content = styled.div`
  margin-block-start: 8px;
`;

export const Headline = styled.div`
  display: -webkit-box;

  block-size: 80px;

  color: #000000;
  font-weight: 700;
  font-size: 15px;
  font-family: ${fontRobotoCondensed};
  line-height: 1.4;
  text-overflow: ellipsis;

  overflow: hidden;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4;
  /* stylelint-disable property-no-unknown */
  line-clamp: 4;
  /* stylelint-enable property-no-unknown */
`;

export const SponsorContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;

  margin-block-start: 12px;
`;

export const SponsorType = styled.div`
  padding-block-start: 8px;

  border-block-start: 1px solid #dfdfdf;

  color: #727272;
  font-weight: 400;
  font-size: 10px;
  font-family: ${fontRoboto};
`;

export const SponsorName = styled.div`
  color: #000000;
  font-weight: 700;
  font-size: 12px;
  font-family: ${fontRoboto};
`;
